import { render } from "./AssignmentEdit.vue?vue&type=template&id=64cd34b6&scoped=true&ts=true"
import script from "./AssignmentEdit.vue?vue&type=script&lang=ts"
export * from "./AssignmentEdit.vue?vue&type=script&lang=ts"

import "./AssignmentEdit.vue?vue&type=style&index=0&id=64cd34b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cd34b6"]])

export default __exports__